import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthService {
  constructor(private http: HttpClient,public jwtHelper: JwtHelperService) { }
  /**
   * Envia datos al servidor a validar
   * @param username  Correo ingresado por el usuario.
   * @param password  Contraseña ingresada por el usuario.
   * @param token  Valor que regresa el servidor y se almacena
   * en el localSotarge
  **/
  login(username: string, password: string): Observable<boolean> {
    return this.http.post<{token: string}>('https://vigiliner.com.mx:1829/api/auth', {username: username, password: password})
      .pipe(
        map(result => {
          localStorage.setItem('access_token', result.token);
          return true;
        })
      );
  }
  /**
   * Remueve el token de localStorage
  **/
  logout() {
    localStorage.removeItem('access_token');
  }
  /**
   * Valida si el token es valido obteniendolo
   * del localStorage
  **/
  public get loggedIn(): boolean {
    try{
      this.jwtHelper.decodeToken(localStorage.getItem('access_token'))
    }catch(error){
      return false;
    }

    try{
      this.jwtHelper.isTokenExpired()
    }catch(error){
      return false;
    }

    if(this.jwtHelper.isTokenExpired())
      return false;

    return (localStorage.getItem('access_token') !== null);
  }
}